var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlanBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 77,
    viewBox: "0 0 57 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1045L28.5 34.2238V76.9852L0 59.8806V17.1045Z",
    fill: "#2782FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 34.2092L57 17.0898V59.8808L28.5 77.0001V34.2092Z",
    fill: "#4C94F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1045L28.5 0L57 17.1045L28.5 34.2091L0 17.1045Z",
    fill: "#3385F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 17.1047L28.5 2.13818L53.4375 17.1047L28.6272 32.0711L3.5625 17.1047Z",
    fill: "#4494FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 21.247L42.75 12.8284V17.1045L28.5 25.6568V21.247Z",
    fill: "#5EA0F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 17.1045V12.8284L28.5 21.3806V25.6568L14.25 17.1045Z",
    fill: "#2782FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.8284L28.5 4.27612L42.75 12.8284L28.5 21.3807L14.25 12.8284Z",
    fill: "#3385F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78125 26.7258L4.45313 28.3294V32.6055L1.78125 31.002V26.7258Z",
    fill: "#1953A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16309 26.9585L4.45326 28.3293V32.0709L2.16309 30.7346V26.9585Z",
    fill: "#1364CF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78125 35.2781L4.45313 36.8816V41.1578L1.78125 39.5542V35.2781Z",
    fill: "#1953A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16309 35.5107L4.45326 36.8816V40.6232L2.16309 39.2869V35.5107Z",
    fill: "#1364CF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78125 43.8303L4.45313 45.4339V49.71L1.78125 48.1065V43.8303Z",
    fill: "#1953A2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16309 44.063L4.45326 45.4338V49.1754L2.16309 47.8391V44.063Z",
    fill: "#1364CF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78125 52.3828L4.45313 53.9864V58.2625L1.78125 56.659V52.3828Z",
    fill: "#1953A2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16309 52.6155L4.45326 53.9863V57.7279L2.16309 56.3916V52.6155Z",
    fill: "#1364CF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 31.002L11.5781 32.6055V36.8816L8.90625 35.2781V31.002Z",
    fill: "#1953A2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28809 31.2346L11.5783 32.6054V36.3471L9.28809 35.0108V31.2346Z",
    fill: "#1364CF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 39.5542L11.5781 41.1577V45.4339L8.90625 43.8303V39.5542Z",
    fill: "#1953A2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28809 39.7869L11.5783 41.1577V44.8993L9.28809 43.563V39.7869Z",
    fill: "#1364CF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 48.1064L11.5781 49.71V53.9861L8.90625 52.3826V48.1064Z",
    fill: "#1953A2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28809 48.3391L11.5783 49.7099V53.4515L9.28809 52.1153V48.3391Z",
    fill: "#1364CF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 56.6587L11.5781 58.2622V62.5384L8.90625 60.9348V56.6587Z",
    fill: "#1953A2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28809 56.8914L11.5783 58.2622V62.0038L9.28809 60.6675V56.8914Z",
    fill: "#1364CF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7773 35.0107L18.4492 36.6143V40.8904L15.7773 39.2869V35.0107Z",
    fill: "#1953A2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1592 35.2434L18.4494 36.6142V40.3558L16.1592 39.0195V35.2434Z",
    fill: "#1364CF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7773 43.563L18.4492 45.1665V49.4427L15.7773 47.8391V43.563Z",
    fill: "#1953A2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1592 43.7957L18.4494 45.1665V48.9081L16.1592 47.5718V43.7957Z",
    fill: "#1364CF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7773 52.1155L18.4492 53.719V57.9952L15.7773 56.3916V52.1155Z",
    fill: "#1953A2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1592 52.3481L18.4494 53.719V57.4606L16.1592 56.1243V52.3481Z",
    fill: "#1364CF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7773 60.6677L18.4492 62.2713V66.5474L15.7773 64.9439V60.6677Z",
    fill: "#1953A2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1592 60.9004L18.4494 62.2712V66.0128L16.1592 64.6765V60.9004Z",
    fill: "#1364CF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9014 39.2871L25.5732 40.8907V45.1668L22.9014 43.5633V39.2871Z",
    fill: "#1953A2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2832 39.5198L25.5734 40.8906V44.6322L23.2832 43.2959V39.5198Z",
    fill: "#1364CF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9014 47.8394L25.5732 49.4429V53.719L22.9014 52.1155V47.8394Z",
    fill: "#1953A2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2832 48.072L25.5734 49.4428V53.1845L23.2832 51.8482V48.072Z",
    fill: "#1364CF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9014 56.3916L25.5732 57.9952V62.2713L22.9014 60.6678V56.3916Z",
    fill: "#1953A2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2832 56.6243L25.5734 57.9951V61.7367L23.2832 60.4004V56.6243Z",
    fill: "#1364CF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9014 64.9438L25.5732 66.5474V70.8235L22.9014 69.22V64.9438Z",
    fill: "#1953A2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2832 65.1765L25.5734 66.5473V70.2889L23.2832 68.9526V65.1765Z",
    fill: "#1364CF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2812 41.8259L32.8259 40.356V44.6321L30.2812 46.102V41.8259Z",
    fill: "#1953A2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2812 41.826L32.4442 40.5774V44.365L30.2812 45.5676V41.826Z",
    fill: "#1364CF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2988 50.3784L33.8435 48.9084V53.1846L31.2988 54.6545V50.3784Z",
    fill: "#1953A2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2988 50.3785L33.4618 49.1299V52.9174L31.2988 54.1201V50.3785Z",
    fill: "#1364CF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2988 58.1286L33.8435 56.6587V60.9348L31.2988 62.4047V58.1286Z",
    fill: "#1953A2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2988 58.1287L33.4618 56.8801V60.6677L31.2988 61.8704V58.1287Z",
    fill: "#1364CF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2988 66.4138L33.8435 64.9438V69.22L31.2988 70.6899V66.4138Z",
    fill: "#1953A2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2988 66.4139L33.4618 65.1653V68.9528L31.2988 70.1555V66.4139Z",
    fill: "#1364CF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4072 37.5498L39.9519 36.0798V40.356L37.4072 41.8259V37.5498Z",
    fill: "#1953A2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4062 37.5499L39.5692 36.3013V40.0888L37.4062 41.2915V37.5499Z",
    fill: "#1364CF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4248 46.102L40.9694 44.6321V48.9082L38.4248 50.3781V46.102Z",
    fill: "#1953A2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4238 46.1021L40.5868 44.8535V48.6411L38.4238 49.8437V46.1021Z",
    fill: "#1364CF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4248 53.8527L40.9694 52.3828V56.6589L38.4248 58.1289V53.8527Z",
    fill: "#1953A2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4238 53.8528L40.5868 52.6042V56.3918L38.4238 57.5945V53.8528Z",
    fill: "#1364CF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4248 62.1376L40.9694 60.6677V64.9439L38.4248 66.4138V62.1376Z",
    fill: "#1953A2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4238 62.1378L40.5868 60.8892V64.6767L38.4238 65.8794V62.1378Z",
    fill: "#1364CF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2783 33.2736L46.823 31.8037V36.0798L44.2783 37.5498V33.2736Z",
    fill: "#1953A2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2773 33.2737L46.4403 32.0251V35.8127L44.2773 37.0154V33.2737Z",
    fill: "#1364CF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2949 41.8259L47.8396 40.356V44.6321L45.2949 46.102V41.8259Z",
    fill: "#1953A2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2949 41.826L47.4579 40.5774V44.365L45.2949 45.5676V41.826Z",
    fill: "#1364CF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2949 49.5764L47.8396 48.1064V52.3826L45.2949 53.8525V49.5764Z",
    fill: "#1953A2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2949 49.5765L47.4579 48.3279V52.1154L45.2949 53.3181V49.5765Z",
    fill: "#1364CF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2949 57.8615L47.8396 56.3916V60.6677L45.2949 62.1376V57.8615Z",
    fill: "#1953A2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2949 57.8616L47.4579 56.613V60.4006L45.2949 61.6033V57.8616Z",
    fill: "#1364CF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4014 28.9975L53.946 27.5276V31.8037L51.4014 33.2736V28.9975Z",
    fill: "#1953A2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4014 28.9976L53.5643 27.749V31.5366L51.4014 32.7392V28.9976Z",
    fill: "#1364CF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4199 37.5498L54.9646 36.0798V40.356L52.4199 41.8259V37.5498Z",
    fill: "#1953A2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4199 37.5499L54.5829 36.3013V40.0888L52.4199 41.2915V37.5499Z",
    fill: "#1364CF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4199 45.3002L54.9646 43.8303V48.1065L52.4199 49.5764V45.3002Z",
    fill: "#1953A2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4199 45.3004L54.5829 44.0518V47.8393L52.4199 49.042V45.3004Z",
    fill: "#1364CF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4199 53.5854L54.9646 52.1155V56.3916L52.4199 57.8615V53.5854Z",
    fill: "#1953A2"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4199 53.5855L54.5829 52.3369V56.1245L52.4199 57.3271V53.5855Z",
    fill: "#1364CF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.2427L28.5 36.3472V38.4853L0 21.3807V19.2427Z",
    fill: "#70ABFB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.717L28.5 39.8216V40.6234L0 23.5188V22.717Z",
    fill: "#70ABFB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 36.3472L57 19.2427V21.3807L28.5 38.4853V36.3472Z",
    fill: "#7BB0F7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 39.8216L57 22.717V23.5188L28.5 40.6234V39.8216Z",
    fill: "#7BB0F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanBusiness);
export default __webpack_public_path__ + "static/media/icon-plan-business.7462c3ab.svg";
export { ForwardRef as ReactComponent };